import { put, take } from 'redux-saga/effects'
import * as endpoints from '../constants/RabbitQueueEndpoints';
import * as actions from '../actions/chatActions';

export const endpoint = endpoints.QUEUE_API_RESPONSES;

export const handler = (emit, message) =>
  emit(actions.apiResponseReceived(message));

export function* read(queue) {
  while (true) {
    const apiResponse = yield take(queue);
    yield put(apiResponse);
  }
}
